import {requests} from "../../helpers/api.services";
import {NEWS_URL} from "../../helpers/api.routes";

export const AdminInFocusService = {
    getAll: () => requests.get(`${NEWS_URL}/in-focus/all`),
    update: (id?: any) => requests.put(`${NEWS_URL}/in-focus/${id}`, true),
    updatePosition: (params: any) => requests.patch(`${NEWS_URL}/in-focus`, params),
}